import { z } from "zod";
import {
  clockEventKindSchema,
  clockStateSchema,
  eventSourceSchema,
  instantSchema,
  localDateSchema,
} from "./schemas";

/*
 * Runtime schemas of recording for others (T-170, ADR-0139). They mirror `backend/openapi.json` like
 * `schemas.ts`.
 */

/** A person the signed-in manager or HR administrator may clock for. */
export const crewMemberSchema = z.object({
  employeeId: z.uuid(),
  displayName: z.string(),
  personnelNumber: z.string(),
  timeZoneId: z.string().nullable(),
  state: clockStateSchema,
  since: instantSchema.nullable(),
});

/** `GET /me/crew`. */
export const crewSchema = z.object({
  date: localDateSchema,
  members: z.array(crewMemberSchema),
});

/**
 * A clock event another person recorded for the signed-in person, or one the person recorded at a terminal after a
 * sign-in checked only on the device (`verifiedOfflineAtTerminal`, T-173).
 */
export const proxyEntrySchema = z.object({
  eventId: z.uuid(),
  kind: clockEventKindSchema,
  occurredAt: instantSchema,
  recordedAt: instantSchema,
  source: eventSourceSchema,
  recordedByEmployeeId: z.uuid(),
  recordedByDisplayName: z.string().nullable(),
  verifiedOfflineAtTerminal: z.boolean().default(false),
});

/** `GET /me/proxy-entries`. */
export const proxyEntriesSchema = z.object({
  entries: z.array(proxyEntrySchema),
});

/** A person to clock for. */
export type CrewMember = z.infer<typeof crewMemberSchema>;
/** The persons to clock for. */
export type Crew = z.infer<typeof crewSchema>;
/** A clock event another person recorded for the signed-in person. */
export type ProxyEntry = z.infer<typeof proxyEntrySchema>;
